<div class="customer-events">
  <div class="heading">
    <div>
      <span>{{ 'label.JobFairs' | translate }}</span>
    </div>
  </div>
  <div class="content">
    <table class="list">
      <thead>
        <tr>
          <th>{{ 'label.StartDate' | translate }}</th>
          <th>{{ 'label.EndDate' | translate }}</th>
          <th>{{ 'label.Name' | translate }}</th>
          <th>{{ 'label.Package' | translate }}</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let event of customer?.events">
          <td>{{ event.startDate | date : 'dd/MM/yyyy' }}</td>
          <td>{{ event.endDate | date : 'dd/MM/yyyy' }}</td>
          <td>{{ event.name }}</td>
          <td>{{ event.packageName }}</td>
          <td>
            <button
              *ngIf="event.isActive && hasManageJobFairsPermission"
              pButton
              type="button"
              class="ui-button-secondary"
              (click)="onDelete(event.eventId)"
              label="{{ 'label.Delete' | translate }}"
            ></button>
          </td>
          <td>
            <button
              *ngIf="event.isActive && hasManageJobFairsPermission"
              [disabled]="!event.eventCvDatabaseAccessNotGranted"
              pButton
              type="button"
              class="ui-button-secondary"
              (click)="onRequestEventCvDatabaseAccess(event)"
              label="{{ 'label.CvDatabase' | translate }}"
            ></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <hr-customer-add-jobfair
    *ngIf="hasManageJobFairsPermission"
    [display]="addModeOn"
    [customer]="customer?.customerId"
    [registeredEvents]="customer?.events"
    (onUpdate)="onUpdateTable($event)"
  ></hr-customer-add-jobfair>
  <hr-customer-request-event-cv-db-access
    *ngIf="hasManageJobFairsPermission"
    [display]="requestModeOn"
    [event]="selectedParticipant"
    [items]="storeItems"
    (onUpdate)="onUpdateTable($event)"
  ></hr-customer-request-event-cv-db-access>
  <button
    *ngIf="customer?.statusId == customerStatusEnum.Active"
    pButton
    type="button"
    class="ui-button-secondary"
    [disabled]="!hasManageJobFairsPermission"
    (click)="onAdd()"
    label="{{ 'label.AddToJobFair' | translate }}"
    style="float: right; margin-top: 1em; margin-bottom: 0.5em"
  ></button>
</div>
